<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton v-show="isGuide != 'process'" slot="extra">返回</v-gobackbutton>
            <a-form-model :model="domainData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="domain" label="域名" prop="domain">
                    <a-input v-model="domainData.domain" v-if="is_vue_task" @blur="
                        () => {
                            $refs.domain.onFieldBlur();
                        }
                        " />
                    <span class="form_span" v-else>{{domainData.domain}}</span>
                </a-form-model-item>
                <a-form-model-item label="内外网" prop="routetype">
                    <a-select v-model="domainData.routetype" placeholder="选择内外网" style="width:181.25px">
                        <a-select-option value="外网">
                            外网
                        </a-select-option>
                        <a-select-option value="内网">
                            内网
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
               <a-form-model-item label="域名描述" ref="domaindesc" prop="domaindesc" :labelCol="labelCol" :wrapperCol="wrapperCol"
                    style="width:100%;margin-top:10px;">
                    <a-input v-model="domainData.domaindesc" v-if="is_vue_task" type="textarea" @blur="() => {
                                $refs.domaindesc.onFieldBlur();
                            }
                            " />
                    <span class="form_span" v-else>{{domainData.domaindesc}}</span>
                </a-form-model-item>
                <a-form-model-item label="备注" ref="remark" prop="remark" :labelCol="labelCol" :wrapperCol="wrapperCol"
                    style="width:100%;margin-top:10px;">
                    <a-input v-model="domainData.remark" v-if="is_vue_task" type="textarea" @blur="() => {
                                $refs.remark.onFieldBlur();
                            }
                            " />
                    <span class="form_span" v-else>{{domainData.remark}}</span>
                </a-form-model-item>
             
                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }" v-show="is_vue_task">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    'adddomainurl':'新增域名',
    'detaildomainurl':'查看域名',
    'editdomainurl':'编辑域名',
    'copydomainurl':'复制域名'
};
export default {
    data() {
        return {
            m_title,
            c_title:'',
            labelCol: { span: 6 },
            wrapperCol: { span:8 },
            rules: {
                domain: [
                    { required: true, message: '请输入域名', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                domaindesc:[
                    { min: 1, max: 500, message: '请输入1~500个字符', trigger: 'blur' },
                ],
                remark:[
                    { min: 1, max: 500, message: '请输入1~500个字符', trigger: 'blur' },
                ]
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            domainData:{},
            selecterState:{
                isShow:false,
                rowsType:'radio' // or 'checkbox'，单选或多选
            },
            is_vue_task : true,
        };
    },
    components: {
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    console.log(this.domainData);
                    const { params } = this.$route;
                    if(this.domainData.id && params.action != 'copydomainurl'){
                        //编辑
                        this.$store
                            .dispatch({
                                type: "sys/updateDomainUrl",
                                params: this.domainData
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel()
                                    this.confirmLoading = false;
                                }
                            });
                    }
                    else{
                        //新增
                        this.$store
                            .dispatch({
                                type: "sys/addDomainUrl",
                                params: this.domainData
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    this.handleCancel()
                                }
                                this.confirmLoading = false;


                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    props:{
        isGuide:String
    },
    mounted() {
        const { query, params } = this.$route;
        if(this.isGuide == "process"){
            params.action = "adddomainurl";
        }
        this.c_title = m_title[params.action];
        this.is_vue_task = params.action != 'detaildomainurl';
        let that = this;
        if (params.action != "adddomainurl") {
            that.$store.dispatch({
                type: "sys/detailDomainUrl",
                params:query
            }).then((res)=>{
                console.log(res);
                that.tLoading = false;
                let result = res.data.data;
                that.domainData = result
            })
        }
        else{
            this.domainData = {
                id:'',
                appcode:'',
                domain:'',
                remark:''
            }
        }

    }
};
</script>

<style lang="less" scoped>
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
</style>
